export const GET_DATA = "GET_DATA";
export const GET_SINGLE_CARD = "GET_SINGLE_CARD";
export const GET_CHAR_CARD = "GET_CHAR_CARD";


// set settings
export const NAVIGATION = "NAVIGATION";
export const WALLET = "WALLET";
export const SEARCH = "SEARCH";
